/* team-card-header.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./team-card-header.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { useIntl } from 'react-intl-next';
import DepartmentIcon from '@atlaskit/icon/core/department';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import TeamsAvatar from '@atlaskit/teams-avatar';
import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { messages } from '../../messages';
import { KnowledgeCardHeader } from '../common/knowledge-card-header';
import { KnowledgeCardsIntentType } from '../types';
import { useTeamsAppLinks } from '../use-teams-app-links';
var styles = {
  orgIcon: "_u5f31b66 _19bv1b66"
};
export var TeamCardHeader = function TeamCardHeader(_ref) {
  var name = _ref.name,
    accountId = _ref.accountId,
    email = _ref.email,
    avatarUrl = _ref.avatarUrl,
    teamId = _ref.teamId,
    profileUrl = _ref.profileUrl;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var cloudId = commonAttributes.cloudId;
  var _useTeamsAppLinks = useTeamsAppLinks({
      type: KnowledgeCardsIntentType.TEAM,
      currentUserId: accountId !== null && accountId !== void 0 ? accountId : '',
      cloudId: cloudId,
      teamId: teamId
    }),
    profileHref = _useTeamsAppLinks.profileHref,
    profileOnNavigate = _useTeamsAppLinks.profileOnNavigate;
  var media = /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(TeamsAvatar, {
    size: "xlarge",
    src: avatarUrl || undefined,
    name: name
  }));
  var orgText = /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.orgIcon
  }, /*#__PURE__*/React.createElement(DepartmentIcon, {
    label: ""
  })), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest"
  }, formatMessage(messages.knowledge_cards_team_subheader)));
  var handleLinkClick = function handleLinkClick(e) {
    if (fg('platform-adopt-teams-nav-config')) {
      profileOnNavigate(e);
    }
  };
  return /*#__PURE__*/React.createElement(KnowledgeCardHeader, {
    name: name,
    email: email,
    profileUrl: fg('platform-adopt-teams-nav-config') ? profileHref : profileUrl || '',
    profileLinkText: formatMessage(messages.knowledge_cards_view_team),
    media: media,
    orgText: orgText,
    onLinkClick: handleLinkClick
  });
};